var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st2{fill:#f0f0f0}\n    ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.131,
    y1: 17,
    x2: 29.869,
    y2: 17,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd141b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#db1921"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.9,
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 .3C23.1.3 29.7 6.9 29.7 15S23.1 29.7 15 29.7.3 23.1.3 15 6.9.3 15 .3m0-.3C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.1 26.7H24c1.1-.8 2.1-1.8 2.9-2.9H3.2c.8 1.1 1.8 2.1 2.9 2.9zM1.1 19.8H29c.3-1 .6-1.9.7-2.9H.4c.1.9.3 1.9.7 2.9zM.4 12.8h29.2c-.1-1-.4-2-.8-2.9H1.2c-.4.9-.6 1.9-.8 2.9zM23.5 2.9h-17c-1.1.9-2.2 1.9-3.1 3h23.1c-.8-1.1-1.9-2.1-3-3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.263,
    y1: 24.369,
    x2: 15,
    y2: 24.369,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0c4da1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3a94d3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15 .3C6.9.3.3 6.9.3 15H15V.3z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m2.6 13.8-.9.4.2-.9-.8-.7 1-.2.5-.9.4.9 1 .2-.7.7.2.9zM6.1 13.8l-.9.4.2-.9-.7-.7 1-.2.4-.9.5.9.9.2-.7.7.2.9zM9.6 13.8l-.9.4.2-.9-.7-.7 1-.2.4-.9.5.9 1 .2-.8.7.2.9zM13.1 13.8l-.8.4.1-.9-.7-.7 1-.2.4-.9.5.9 1 .2-.7.7.1.9zM4.3 10.8l-.8.5.1-1-.7-.7 1-.2.4-.9.5.9 1 .2-.7.7.1 1zM7.9 10.8l-.9.5.1-1-.7-.7 1-.2.5-.9.4.9 1 .2-.7.7.2 1zM11.4 10.8l-.9.5.2-1-.8-.7 1-.2.5-.9.4.9 1 .2-.7.7.2 1zM6.1 7.8l-.9.5.2-1-.7-.7 1-.2.4-.9.5.9.9.2-.7.7.2 1zM9.6 7.8l-.9.5.2-1-.7-.7 1-.2.4-.9.5.9 1 .2-.8.7.2 1zM13.1 7.8l-.8.5.1-1-.7-.7 1-.2.4-.9.5.9 1 .2-.7.7.1 1zM7.9 4.8l-.9.5.1-1-.7-.7 1-.1.5-.9.4.9 1 .1-.7.7.2 1zM11.4 4.8l-.9.5.2-1-.8-.7 1-.1.5-.9.4.9 1 .1-.7.7.2 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 2.7s1.2 4.6 9.2 6.3 8.2 8.9 8.2 8.9c0-.3.2-.8.3-1.1.2-.9.3-1.9.4-2.8.1-2.9-.9-5.7-2.7-7.9-1.6-1.9-3.7-3.3-6.1-3.9-3.1-.6-6.3-.4-9.3.5z",
    style: {
      opacity: 0.2,
      fill: "#fff",
      enableBackground: "new"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnUs);
export default __webpack_public_path__ + "static/media/en_us.7108e73eaf3fae087b7c44efa2b2f733.svg";
export { ForwardRef as ReactComponent };